<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Lost Time Injury (LTI) Record</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="m-0 p-0">
    <form #f="ngForm" (ngSubmit)="onSave()">
      <mat-tab-group>
        <mat-tab label="Affected Person">
          <div class="container-fluid p-0">
            <div class="px-3 py-4">

              <div class="row">
                <div class="col">
                  <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                    <mat-label>Affected Person</mat-label>
                    <input matInput type="text" placeholder="Affected Person" [(ngModel)]="incident_lti.affected_user_contact_person" name="affected_user_contact_person" matTooltip="The name of the affected person." />
                    <mat-hint>Please enter the name of the affected person.</mat-hint>
                  </mat-form-field>
                </div>

                <div class="col">
                  <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                    <mat-label>Affected Person's {{ utils.getLangTerm('users.form.mobile', 'Mobile Number') }}</mat-label>
                    <input matInput type="text" placeholder="Affected Person's {{ utils.getLangTerm('users.form.mobile', 'Mobile Number') }}" [(ngModel)]="incident_lti.affected_user_phone" name="affected_user_phone" matTooltip="The {{ utils.getLangTerm('users.form.mobile', 'Mobile Number') }} of the affected person." />
                    <mat-hint>Please enter the {{ utils.getLangTerm('users.form.mobile', 'Mobile Number') }} of the affected person.</mat-hint>
                  </mat-form-field>
                </div>

                <div class="col">
                  <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                    <mat-label>Affected Person's Email Address</mat-label>
                    <input matInput type="text" placeholder="Affected Person's Email Address" [(ngModel)]="incident_lti.affected_user_email" name="affected_user_email" matTooltip="The email address of the affected person." />
                    <mat-hint>Please enter the email address of the affected person.</mat-hint>
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div class="col d-flex justify-content-end">
                  <button mat-raised-button type="button" class="m-1 mr-0" (click)="onSelectUser()" [disabled]="!f.valid" color="secondary"><mat-icon>account_circle</mat-icon> Select User</button>
                </div>
              </div>

            </div>
          </div>
        </mat-tab>

        <mat-tab [label]="utils.getLangTerm('incidents.lti.health-provider-tab', 'Health Provider')">
          <div class="container-fluid p-0">
            <div class="px-3 py-4">

              <div class="row">
                <div class="col">
                  <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                    <mat-label>{{ utils.getLangTerm('incidents.lti.health-provider-name', "Health Provider's Name") }}</mat-label>
                    <input matInput type="text" [placeholder]="utils.getLangTerm('incidents.lti.health-provider-name', 'Health Provider\'s Name')" [(ngModel)]="incident_lti.health_provider_name" name="health_provider_name" [matTooltip]="'The name of the ' + utils.getLangTerm('incidents.lti.health-provider-tab', 'Health Provider') + '.'" />
                    <mat-hint>Please enter the name of the {{ utils.getLangTerm('incidents.lti.health-provider-tab', 'Health Provider') }}.</mat-hint>
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                    <mat-label>{{ utils.getLangTerm('incidents.lti.health-provider-contact', 'Health Provider Main Contact') }}</mat-label>
                    <input matInput type="text" [placeholder]="utils.getLangTerm('incidents.lti.health-provider-contact', 'Health Provider Main Contact')" [(ngModel)]="incident_lti.health_provider_contact_person" name="health_provider_contact_person" [matTooltip]="'The name of the main contact at the ' + utils.getLangTerm('incidents.lti.health-provider-tab', 'Health Provider') + '.'" />
                    <mat-hint>Please enter the name of the main contact for the {{ utils.getLangTerm('incidents.lti.health-provider-tab', 'Health Provider') }}.</mat-hint>
                  </mat-form-field>
                </div>

                <div class="col">
                  <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                    <mat-label>{{ utils.getLangTerm('incidents.lti.health-provider-phone', 'Health Provider Contact Number') }}</mat-label>
                    <input matInput type="text" [placeholder]="utils.getLangTerm('incidents.lti.health-provider-phone', 'Health Provider Contact Number')" [(ngModel)]="incident_lti.health_provider_phone" name="health_provider_phone" [matTooltip]="'The phone number of the main contact at the ' + utils.getLangTerm('incidents.lti.health-provider-tab', 'Health Provider') + '.'" />
                    <mat-hint>Please enter the phone number of the main contact for the {{ utils.getLangTerm('incidents.lti.health-provider-tab', 'Health Provider') }}.</mat-hint>
                  </mat-form-field>
                </div>

                <div class="col">
                  <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                    <mat-label>{{ utils.getLangTerm('incidents.lti.health-provider-email', 'Health Provider Email Address') }}</mat-label>
                    <input matInput type="text" [placeholder]="utils.getLangTerm('incidents.lti.health-provider-email', 'Health Provider Email Address')" [(ngModel)]="incident_lti.health_provider_email" name="health_provider_email" [matTooltip]="'The email address of the main contact at the ' + utils.getLangTerm('incidents.lti.health-provider-tab', 'Health Provider') + '.'" />
                    <mat-hint>Please enter the email address of the main contact for the {{ utils.getLangTerm('incidents.lti.health-provider-tab', 'Health Provider') }}.</mat-hint>
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <mat-form-field class="full-width mb-0" appearance="outline" subscriptSizing="dynamic">
                    <mat-label>{{ utils.getLangTerm('incidents.lti.health-provider-description', 'Health Provider Description') }}</mat-label>
                    <textarea matInput [placeholder]="utils.getLangTerm('incidents.lti.health-provider-description', 'Health Provider Description')" [(ngModel)]="incident_lti.health_provider_description" name="health_provider_description" rows="5" [matTooltip]="'Enter any additional ' + utils.getLangTerm('incidents.lti.health-provider-tab', 'Health Provider') + ' comments.'"></textarea>
                    <mat-hint>Use this description input field to capture additional comments and feedback for the {{ utils.getLangTerm('incidents.lti.health-provider-tab', 'Health Provider') }}.</mat-hint>
                  </mat-form-field>
                </div>
              </div>

            </div>
          </div>
        </mat-tab>

        <mat-tab [label]="utils.getLangTerm('incidents.lti.acc-tab', 'ACC Case Manager')">
          <div class="container-fluid p-0">
            <div class="px-3 py-4">

              <div class="row">
                <div class="col">
                  <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                    <mat-label>{{ utils.getLangTerm('incidents.lti.acc-office-name', "ACC Case Manager's Office Name") }}</mat-label>
                    <input matInput type="text" [placeholder]="utils.getLangTerm('incidents.lti.acc-office-name', 'ACC Case Manager\'s Office Name')" [(ngModel)]="incident_lti.acc_case_manager_office_name" name="acc_case_manager_office_name" [matTooltip]="'The name of the ' + utils.getLangTerm('incidents.lti.acc-office-name', 'ACC Case Manager\'s Office Name').toLowerCase() + '.'" />
                    <mat-hint>Please enter the name of the {{ utils.getLangTerm('incidents.lti.acc-office-name', "ACC Case Manager's Office Name").toLowerCase() }}.</mat-hint>
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                    <mat-label>{{ utils.getLangTerm('incidents.lti.acc-contact-name', "ACC Case Manager's Name") }}</mat-label>
                    <input matInput type="text" [placeholder]="utils.getLangTerm('incidents.lti.acc-contact-name', 'ACC Case Manager\'s Name')" [(ngModel)]="incident_lti.acc_case_manager_contact_person" name="acc_case_manager_contact_person" [matTooltip]="'The name of the ' + utils.getLangTerm('incidents.lti.acc-tab', 'ACC Case Manager').toLowerCase() + '.'" />
                    <mat-hint>Please enter the name of the {{ utils.getLangTerm('incidents.lti.acc-tab', 'ACC Case Manager').toLowerCase() }}.</mat-hint>
                  </mat-form-field>
                </div>

                <div class="col">
                  <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                    <mat-label>{{ utils.getLangTerm('incidents.lti.acc-phone', "ACC Case Manager's Contact Number") }}</mat-label>
                    <input matInput type="text" [placeholder]="utils.getLangTerm('incidents.lti.acc-phone', 'ACC Case Manager\'s Contact Number')" [(ngModel)]="incident_lti.acc_case_manager_phone" name="acc_case_manager_phone" [matTooltip]="'The contact number of the ' + utils.getLangTerm('incidents.lti.acc-tab', 'ACC Case Manager').toLowerCase() + '.'" />
                    <mat-hint>Please enter the contact number of the {{ utils.getLangTerm('incidents.lti.acc-tab', 'ACC Case Manager').toLowerCase() }}.</mat-hint>
                  </mat-form-field>
                </div>

                <div class="col">
                  <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                    <mat-label>{{ utils.getLangTerm('incidents.lti.acc-email', "ACC Case Manager's Email Address") }}</mat-label>
                    <input matInput type="text" [placeholder]="utils.getLangTerm('incidents.lti.acc-email', 'ACC Case Manager\'s Email Address')" [(ngModel)]="incident_lti.acc_case_manager_email" name="acc_case_manager_email" [matTooltip]="'The email address of the ' + utils.getLangTerm('incidents.lti.acc-tab', 'ACC Case Manager').toLowerCase() + '.'" />
                    <mat-hint>Please enter the email address of the {{ utils.getLangTerm('incidents.lti.acc-tab', 'ACC Case Manager').toLowerCase() }}.</mat-hint>
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <mat-form-field class="full-width mb-0" appearance="outline" subscriptSizing="dynamic">
                    <mat-label>{{ utils.getLangTerm('incidents.lti.acc-description', "ACC Case Manager's Description") }}</mat-label>
                    <textarea matInput [placeholder]="utils.getLangTerm('incidents.lti.acc-description', 'ACC Case Manager\'s Description')" [(ngModel)]="incident_lti.acc_case_manager_description" name="acc_case_manager_description" rows="5" [matTooltip]="'Enter any additional comments here.'"></textarea>
                    <mat-hint>Use this description input field to capture additional comments or feedback for the {{ utils.getLangTerm('incidents.lti.acc-tab', 'ACC Case Manager').toLowerCase() }}.</mat-hint>
                  </mat-form-field>
                </div>
              </div>

            </div>
          </div>
        </mat-tab>

        <mat-tab [label]="utils.getLangTerm('incidents.lti.return-to-work-tab', 'Return to Work')">
          <div class="container-fluid p-0">
            <div class="px-3 py-4">

              <div class="row">
                <div class="col">
                  <app-timezone-select [timezoneInput]="selectedEstimatedTimezone" (timezoneOutput)="getOutputEstimatedTimezone($event)"></app-timezone-select>
                </div>
                <div class="col">
                  <app-timezone-select [timezoneInput]="selectedActualTimezone" (timezoneOutput)="getOutputActualTimezone($event)"></app-timezone-select>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <app-datetime-picker
                    [selectedDateTime]="estimatedDateTime"
                    [pickerName]="'estimatedDateTime'"
                    [label]="'Estimated Date:'"
                    [hint]="'Click the calendar icon to select a date and time.'"
                    [selectTooltip]="'Select the date.'"
                    [removeTooltip]="'Remove the date.'"
                    [classes]="'full-width mb-4'"
                    (pickerDetailsOutput)="getOutputEstimatedDateTimeDetails($event)"></app-datetime-picker>
                </div>

                <div class="col">
                  <app-datetime-picker
                    [selectedDateTime]="actualDateTime"
                    [pickerName]="'actualDateTime'"
                    [label]="'Actual Date:'"
                    [hint]="'Click the calendar icon to select a date and time.'"
                    [selectTooltip]="'Select the date.'"
                    [removeTooltip]="'Remove the date.'"
                    [classes]="'full-width mb-4'"
                    (pickerDetailsOutput)="getOutputActualDateTimeDetails($event)"></app-datetime-picker>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <mat-form-field class="full-width mb-0" appearance="outline" subscriptSizing="dynamic">
                    <mat-label>{{ utils.getLangTerm('incidents.lti.return-to-work-tab', 'Return to Work') }} Description</mat-label>
                    <textarea matInput [placeholder]="utils.getLangTerm('incidents.lti.return-to-work-tab', 'Return to Work') + ' Description'" [(ngModel)]="incident_lti.return_to_work_description" name="return_to_work_description" rows="5" [matTooltip]="'Enter the ' + utils.getLangTerm('incidents.lti.return-to-work-tab', 'Return to Work').toLowerCase() + ' description here.'"></textarea>
                    <mat-hint>Please enter the {{ utils.getLangTerm('incidents.lti.return-to-work-tab', 'Return to Work').toLowerCase() }} description here.</mat-hint>
                  </mat-form-field>
                </div>
              </div>

            </div>
          </div>
        </mat-tab>

        <mat-tab label="Time Records" *ngIf="incident_lti.incident_lti_id">
          <app-incidents-ltis-time-records [incident]="incident" [incident_lti]="incident_lti" (closed_incident_lti_time_record_evt)="getIncidentLti(incident_lti.incident_lti_id)"></app-incidents-ltis-time-records>
        </mat-tab>
      </mat-tab-group>
    </form>
</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="p-3">
  <button
    mat-raised-button
    type="button"
    color="primary"
    class="my-2 ml-1 mr-2"
    (click)="onSave()"
    [disabled]="!f.valid">
    <mat-icon>save</mat-icon>
    Save
  </button>

  <app-file-browse-button
    parentObjectType="incident_lti"
    [parentObjectId]="incident_lti.incident_lti_id"
    [filesCount]="incident_lti.files.length"
    (afterDialogClosedEvent)="getIncidentLti(incident_lti.incident_lti_id)"
    (selectedFiles)="onSelectFiles($event)">
  </app-file-browse-button>
</mat-dialog-actions>
